import planAssignment from './plan-assignment/all';
import planConfiguration from './plan-configuration/all';
import commissionApprovals from './commission-approvals/all';
import hrReport from './hr-report/all';

export default function (nameController, nameAction, namePage){
    if(nameController === 'commissionplanassignment'){
        planAssignment();
    }

    if (nameController === 'commissionplanapprovals') {
        commissionApprovals(nameAction);
    }

    if (nameController === 'commissionplanconfigurations') {
        planConfiguration();
    }

    if (nameController === 'hrreport') {
        hrReport();
    }
}

